import React from "react"
import styled from "styled-components"
import MembersSection from "./MembersSection"
import ToolsSection from "./ToolsSection"
import Container from "../components/Container"
import Header from "./BigHeader"
import SubHeader from "./SubHeader"
import P from "./P"

class TeamSection extends React.Component {
  render() {
    return (
      <>
        <Container>
          <Header>The Team</Header>
          <P>
            The team consisted of Sooyoung (Stella) Park and myself as the UX
            designers with Dr. Hollingsworth as our advisor. Youmin Park helped
            creating the graphics and visuals, though she was not enrolled in
            the independent study.
          </P>
          <SubHeader>Main Tasks</SubHeader>
          <ol>
            <li>Users Insights and Ideation</li>
            <li>Research and Interviews</li>
            <li>Brainstorming and Designing</li>
            <li>Wireframing and Prototyping</li>
          </ol>
          <SubHeader>Team Members</SubHeader>
        </Container>
        <MembersSection />
        <ToolsSection />
      </>
    )
  }
}

export default TeamSection
